require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/core-js/library/modules/es7.symbol.observable.js
// module id = 2021
// module chunks = 2